module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/kakao_share-88b1e48e54c517296d207c78b763e5ee.svg";